import React from 'react';
import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { useWorkspaceStore } from 'stores';
import type { SingleSparkRunResponse } from 'types/SparkRun';

type MutationVariables = {
  formInput: string;
};

export function useStartSparkRun({
  sparkID,
}: {
  sparkID: string | undefined | null;
}) {
  const queryClient = useQueryClient();
  const currentWorkspaceID = useWorkspaceStore(
    React.useCallback((state) => state.currentWorkspaceID, [])
  );
  const startSparkRun = ({ formInput }: MutationVariables) => {
    if (!currentWorkspaceID) {
      Promise.reject('No workspace found');
    }

    if (!sparkID) {
      Promise.reject('Spark ID can not be null');
    }

    const body = {
      data: {
        type: 'sparkRuns',
        attributes: {
          sparkID: sparkID,
          workspaceID: currentWorkspaceID,
          input: formInput,
        },
      },
    };
    return fetchWrapper<SingleSparkRunResponse>({
      url: `SparkRuns`,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('startSparkRun', startSparkRun, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Start Spark Run: ${error.message}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['SparkRunsQueueJob']);
      queryClient.invalidateQueries(['sparkRun', sparkID]);
    },
  });
}
